import { render, staticRenderFns } from "./AddAgents.vue?vue&type=template&id=fe96a75c&"
import script from "./AddAgents.vue?vue&type=script&lang=js&"
export * from "./AddAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe96a75c')) {
      api.createRecord('fe96a75c', component.options)
    } else {
      api.reload('fe96a75c', component.options)
    }
    module.hot.accept("./AddAgents.vue?vue&type=template&id=fe96a75c&", function () {
      api.rerender('fe96a75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/teams/Create/AddAgents.vue"
export default component.exports